import Wrapper from '../assets/wrappers/JobInfo'

const InformationItemEditInput = ({ icon, type, id, value, placeholder, unit, maxLength }) => {
    return (
        <Wrapper>
            <span className='icon'>{icon}</span>
            <input
                type={type}
                id={id}
                defaultValue={value ? value : null}
                placeholder={placeholder ? placeholder : null} 
                maxLength={maxLength ? maxLength : null}/>
            {unit && <span>&nbsp;{unit}</span>}
        </Wrapper>
    )
}

export default InformationItemEditInput;